import LocalizedStrings from 'react-localization';
import ar from './ar.json';
import en from './en.json';

const Locale = new LocalizedStrings({ en, ar });

export default Locale;
